import { defs as personDefs, person } from './person';

globalThis.defs = {
  person: personDefs,
};
globalThis.API = {
  person,
};
